import { QRCodeSVG }from 'qrcode.react';  // Add this import

// Add this new function at the bottom of the file
export const BitcoinQRCode = ({address, amount}) => {
  const btcAmount = parseFloat(amount);
  const bitcoinURI = `bitcoin:${address}?amount=${btcAmount.toFixed(8)}&label=unisat+order`;

  return (
    <QRCodeSVG
      value={bitcoinURI}
      size={160}
      level="H"
      includeMargin={true}
      fgColor="#000000"
      bgColor="#ffffff"
    />
  );
};
